module.exports = __webpack_public_path__ + "static/img/001@2x.885fd56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/001@2x.png
// module id = vGd1
// module chunks = 1